@switch (shipStatus) {
  @case ('EXPECTED') {
    <span class="fa-stack">
      <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
      <i class="fas fa-lg fa-map-marker-alt fa-stack-1x"></i>
    </span>
  }
  @case ('ARRIVED') {
    <span class="fa-stack" title="{{context.visit.vessel.name}}">
      <i class="fas fa-circle fa-stack-2x"></i>
      <i class="fas fa-lg fa-ship fa-stack-1x fa-inverse"></i>
    </span>
  }
  @case ('DEPARTED') {
    <span class="fa-stack">
      <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
      <i class="fas fa-lg fa-map-marker-alt fa-stack-1x"></i>
    </span>
  }
  @case ('MOVING') {
    <span class="fa-stack">
      <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
      <i class="fas fa-lg fa-map-marker-alt fa-stack-1x"></i>
    </span>
  }
}
